/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Backup frequency options */
export enum BackupFrequency {
  Hourly,
  Daily,
  Weekly,
  Monthly,
}

export type BackupFrequencyArgs = BackupFrequency;

export function getBackupFrequencyEncoder(): FixedSizeEncoder<BackupFrequencyArgs> {
  return getEnumEncoder(BackupFrequency);
}

export function getBackupFrequencyDecoder(): FixedSizeDecoder<BackupFrequency> {
  return getEnumDecoder(BackupFrequency);
}

export function getBackupFrequencyCodec(): FixedSizeCodec<
  BackupFrequencyArgs,
  BackupFrequency
> {
  return combineCodec(getBackupFrequencyEncoder(), getBackupFrequencyDecoder());
}
